const MONTHS = [
  {
    name: 'Janeiro',
    id: 1
  },
  {
    name: 'Fevereiro',
    id: 2
  },
  {
    name: 'Março',
    id: 3
  },
  {
    name: 'Abril',
    id: 4
  },
  {
    name: 'Maio',
    id: 5
  },
  {
    name: 'Junho',
    id: 6
  },
  {
    name: 'Julho',
    id: 7
  },
  {
    name: 'Agosto',
    id: 8
  },
  {
    name: 'Setembro',
    id: 9
  },
  {
    name: 'Outubro',
    id: 10
  },
  {
    name: 'Novembro',
    id: 11
  },
  {
    name: 'Dezembro',
    id: 12
  },
]

const MONTHS_NAME = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Junho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

const YEARS = [
  {
    name: '2024',
    id: 2024
  },
  {
    name: '2023',
    id: 2023
  },
  {
    name: '2022',
    id: 2022
  },
  {
    name: '2021',
    id: 2021
  },
  {
    name: '2020',
    id: 2020
  },
  {
    name: '2019',
    id: 2019
  },
  {
    name: '2018',
    id: 2018
  },
]

const TOTAL_COLABORATORS = [
  {
    name: '0 a 20',
    id: '0-20'
  },
  {
    name: '21 a 50',
    id: '21-50'
  },
  {
    name: '51 a 80',
    id: '51-80'
  },
  {
    name: '81+',
    id: '81+'
  },
]

const TOTAL_COLABORATORS_INT = [
  {
    name: '0 a 20',
    id: 1
  },
  {
    name: '21 a 50',
    id: 2
  },
  {
    name: '51 a 80',
    id: 3
  },
  {
    name: '81+',
    id: 4
  },
]

const SELECT_YES_OR_NO = [
  {
    name: 'Sim',
    id: true,
  },
  {
    name: 'Não',
    id: false,
  },
]

export {
  MONTHS,
  MONTHS_NAME,
  YEARS,
  TOTAL_COLABORATORS,
  TOTAL_COLABORATORS_INT,
  SELECT_YES_OR_NO
}



// WEBPACK FOOTER //
// ./src/assets/js/index.js